function errorParser(error, errorBlock) {
    var errorsMap = {
        'auth/wrong-password'        : 'Login failed. Please make sure you have entered the correct email and password.',
        'auth/weak-password'         : 'Your password must be more than 6 characters long.',
        'auth/email-already-in-use'  : 'An account has already been created with this email. Please sign in or click <a href="#" ' +
        'data-dismiss="modal" data-toggle="modal" data-target="#forgot-password-drawer"> ' +
        'Forgot your password?</a>',
        'auth/operation-not-allowed' : 'Internal login error. Please try again later.',
        'auth/user-not-found'        : 'There is no account associated with this email. Please click ' +
        '<a href="#" data-dismiss="modal" data-toggle="modal" data-target="#sign-up-drawer">Sign up</a>',
        'auth/invalid-email'         : 'email address is not valid',
        'auth/popup-closed-by-user'  : 'The popup has been closed by the user before finalizing the operation'
    };

    var errorText = errorsMap[error.code] ? errorsMap[error.code] : error.message;

    if(errorBlock) {
        $(errorBlock).empty();
        $(errorBlock).append('<li>' + errorText + '</li>');
    }

    return errorText;
}

module.exports = errorParser;


//////////////////
// WEBPACK FOOTER
// ./src/interlock/profile/error-parser.js
// module id = 77
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14